import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Audience() {
  const profiles = [{
    title: 'No sabés cocinar absolutamente nada',
    desc: 'Arrancás desde cero. Sin conocimientos previos. Sin ingredientes raros. Con lo que ya tenés en casa.'
  }, {
    title: 'Vivís solo o empezás a vivir solo',
    desc: 'Primero departamento, primera cocina. Necesitás un sistema claro, no recetas sueltas de internet.'
  }, {
    title: 'Querés ahorrar en comida sin comer mal',
    desc: 'Dejar el delivery no implica comer aburrido. Con el sistema correcto comés mejor y gastás menos.'
  }, {
    title: 'Querés impresionar a familia y visitas',
    desc: 'Ese asado, esa reunión de domingo, esa primera cena con la suegra. Vas a querer estar preparado.'
  }];
  return <section className="py-8 md:py-14 bg-brand-panel/85 backdrop-blur-sm border-y border-brand-border" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-10" data-id="element-20">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-xs md:text-sm mb-2 md:mb-3 block" data-id="element-21">
            ¿Para quién es?
          </span>
          <h2 className="text-xl md:text-4xl font-serif font-bold text-white" data-id="element-22">
            Diseñado exactamente para vos si…
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-2.5 md:gap-4" data-id="element-23">
          {profiles.map((p, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={i} className="flex gap-3 p-3.5 md:p-5 bg-brand-dark rounded-xl border border-brand-border hover:border-brand-gold/30 transition-colors" data-id="element-24">
              <div className="flex-shrink-0 mt-0.5" data-id="element-25">
                <div className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-brand-gold/10 flex items-center justify-center border border-brand-gold/30" data-id="element-26">
                  <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-27" />
                </div>
              </div>
              <div className="min-w-0" data-id="element-28">
                <h3 className="text-sm md:text-base font-bold text-white mb-0.5 md:mb-1 leading-tight" data-id="element-29">
                  {p.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-400 leading-snug" data-id="element-30">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 md:mt-10 text-center" data-id="element-31">
          <p className="text-sm md:text-base text-gray-400" data-id="element-32">
            ¿No estás seguro si es para vos?{' '}
            <span className="text-brand-gold font-semibold cursor-pointer hover:underline" onClick={() => document.getElementById('guarantee')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-33">
              Tenés 7 días de garantía →
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}